import axios from "axios";
import { urlBase } from "../../Constante/Url";
import { UserTockem } from "../../Utils/autenticacao";

function getConfig(params) {
  return {
    headers: { Authorization: `Bearer ${localStorage.getItem(UserTockem)}` },
    params: params,
  };
}

const putAtualizarSenha = async (dados) => {
  const url = urlBase + `usuario/alterar-password/`;
  const config = getConfig();
  const response = await axios.put(url, dados, config);
  return response;
};

const putAlterarSenhaTri7 = async (dados) => {
  const url = urlBase + "usuario/alterar-senha-tri7/";
  const config = getConfig();
  const response = await axios.put(url, dados, config);
  return response;
};

const postEnviarSenhaTri7 = async () => {
  const url = urlBase + "usuario/enviar-senha-tri7/";
  const config = getConfig();
  const response = await axios.get(url, config);
  return response;
};

const getBuscarTokenTri7 = async () => {
  const url = urlBase + "usuario/buscar-token-tri7/";
  const config = getConfig();
  const response = await axios.get(url, config);
  return response;
};

const getBuscarQrCodeTri7 = async () => {
  const url = urlBase + "usuario/buscar-qrcode-tri7/";
  const config = getConfig();
  const response = await axios.get(url, config);
  return response;
};

export const Usuario = {
  putAtualizarSenha,
  putAlterarSenhaTri7,
  postEnviarSenhaTri7,
  getBuscarTokenTri7,
  getBuscarQrCodeTri7,
};
